export default {
  // Options.jsx
  items_per_page: '/ side',
  jump_to: 'GÃ¥ til',
  jump_to_confirm: 'bekrÃ¦ft',
  page: '',

  // Pagination.jsx
  prev_page: 'Forrige Side',
  next_page: 'NÃ¦ste Side',
  prev_5: 'Forrige 5 Sider',
  next_5: 'NÃ¦ste 5 Sider',
  prev_3: 'Forrige 3 Sider',
  next_3: 'NÃ¦ste 3 Sider',
};
